import React from "react";
import LocationCard from "./LocationCard.js";
import { currentLocation } from "../../data/mockLocations.js";

interface CurrentLocationProps {
  className?: string;
}

const CurrentLocation: React.FC<CurrentLocationProps> = ({ className }) => {
  return (
    <div className={`flex-shrink-0 ${className || ""}`}>
      <h2 className="mb-2 text-sm font-semibold text-nearblack-500">
        Votre emplacement actuel
      </h2>
      <LocationCard location={currentLocation} className="min-w-[280px]" />
    </div>
  );
};

export default CurrentLocation;
